var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8518 8.45693C16.0517 8.18386 16.0517 7.81052 15.8518 7.53746L11.0498 0.976814C10.6124 0.37909 9.67537 0.692495 9.67537 1.43655L9.67537 4.88278C9.65725 4.88393 6.81994 5.06575 4.91289 6.30631C2.05198 8.16738 0.408687 12.3561 0.00473923 13.4921C-0.0221495 13.5677 0.0715219 13.6262 0.131094 13.5731C0.753754 13.0181 2.59151 11.5136 4.66866 11.0713C7.62894 10.441 9.66006 10.734 9.67537 10.7362V14.5578C9.67537 15.3019 10.6124 15.6153 11.0498 15.0176L15.8518 8.45693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.98c802b9cdee4bbcb01851eb06bf452e.svg";
export { ForwardRef as ReactComponent };